export const modalBoxStyle = {
    background: "rgba(15, 23, 42, 0.97)",
    borderColor: "rgba(51, 65, 85, 0.5)",
};